// extracted by mini-css-extract-plugin
export default {"primaryColor":"#4d6ed8","primaryColorWithAlpha":"rgba(153,222,141,.1019607843)","mainBgColor":"#1e1e1e","secondBgColor":"#f5f5f5","secondaryColor":"rgba(245,245,245,.1019607843)"};